export class KorintConfigError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'KorintConfigError';
  }
}
